module.exports = __webpack_public_path__ + "static/media/annavaram_group_image2.992e199a.jpg";